import React from 'react';
import { Link } from 'react-router-dom';
import appLogo from '../assets/branding/logo.png';

export default function AuthLayout({ eyebrow, title, subtitle, children, footer }) {
  return (
    <div className="auth-page">
      <section className="auth-story" aria-label="About KinetoCut">
        <div className="auth-story-glow" />
        <Link to="/" className="auth-brand">
          <img src={appLogo} alt="" />
          <span><strong>KinetoCut</strong><small>Video editor</small></span>
        </Link>
        <div className="auth-story-copy">
          <span className="auth-kicker">Create at your pace</span>
          <h2>Simple enough to begin.<br /><span>Powerful enough to finish.</span></h2>
          <p>Move between guided editing and precise controls without leaving your creative flow.</p>
        </div>
        <div className="auth-preview" aria-hidden="true">
          <div className="auth-preview-top"><i /><span>My story</span><small>00:28</small></div>
          <div className="auth-preview-frame"><span className="auth-preview-play">▶</span><b>Weekend escape</b></div>
          <div className="auth-preview-track"><span /><span /><span /><span /><i /></div>
        </div>
        <ul className="auth-promises">
          <li><span>✓</span> Guided and precision editing modes</li>
          <li><span>✓</span> Non-destructive project workflow</li>
          <li><span>✓</span> Export creates a new video</li>
        </ul>
      </section>

      <section className="auth-form-side">
        <div className="auth-mobile-brand">
          <Link to="/" className="auth-brand">
            <img src={appLogo} alt="" />
            <span><strong>KinetoCut</strong><small>Video editor</small></span>
          </Link>
        </div>
        <div className="auth-card">
          <div className="auth-card-heading">
            <span className="eyebrow">{eyebrow}</span>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
          {children}
          {footer && <div className="auth-footer">{footer}</div>}
        </div>
      </section>
    </div>
  );
}

export function PasswordToggle({ visible, onClick }) {
  return (
    <button
      className="password-toggle"
      type="button"
      onClick={onClick}
      aria-label={visible ? 'Hide password' : 'Show password'}
      title={visible ? 'Hide password' : 'Show password'}
    >
      <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        {visible ? (
          <>
            <path d="M3 3 21 21" />
            <path d="M10.6 10.7a2 2 0 0 0 2.7 2.7M9.9 4.2A10.8 10.8 0 0 1 12 4c5.5 0 9 5.5 9 8a10.6 10.6 0 0 1-2.1 3.5M6.6 6.6C4.3 8.1 3 10.5 3 12c0 2.5 3.5 8 9 8 1.5 0 2.8-.4 4-.9" />
          </>
        ) : (
          <>
            <path d="M3 12c0-2.5 3.5-8 9-8s9 5.5 9 8-3.5 8-9 8-9-5.5-9-8Z" />
            <circle cx="12" cy="12" r="2.5" />
          </>
        )}
      </svg>
    </button>
  );
}

export function AuthDivider() {
  return <div className="auth-divider"><span>or continue with</span></div>;
}

export function GoogleIcon() {
  return (
    <svg className="provider-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09Z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23Z" />
      <path fill="#FBBC05" d="M5.84 14.09A6.4 6.4 0 0 1 5.49 12c0-.73.13-1.43.35-2.09V7.07H2.18A11 11 0 0 0 1 12c0 1.78.43 3.45 1.18 4.93l3.66-2.84Z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53Z" />
    </svg>
  );
}

export function AppleIcon() {
  return (
    <svg className="provider-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.365 1.43c0 1.14-.463 2.083-1.315 2.914-.943.916-2.054 1.437-3.15 1.35a3.31 3.31 0 0 1-.023-.394c0-1.088.477-2.088 1.34-2.913C13.99.68 15.152.126 16.09.06c.05.14.275.594.275 1.37Zm3.973 16.42c-.312.72-.69 1.416-1.13 2.084-.6.913-1.09 1.545-1.466 1.895-.585.577-1.213.873-1.884.888-.483 0-1.066-.138-1.75-.417-.685-.278-1.315-.416-1.89-.416-.606 0-1.253.138-1.94.416-.687.279-1.242.425-1.665.44-.643.028-1.286-.276-1.93-.911-.407-.375-.92-1.03-1.535-1.965-.66-.995-1.203-2.148-1.628-3.463C1.09 15.008.87 13.674.87 12.383c0-1.474.32-2.75.958-3.822.5-.86 1.166-1.539 2.003-2.037a5.36 5.36 0 0 1 2.708-.766c.514 0 1.184.16 2.014.472.828.313 1.36.472 1.593.472.174 0 .758-.183 1.752-.55.94-.34 1.734-.481 2.383-.427 1.762.142 3.087.837 3.965 2.088-1.577.955-2.357 2.292-2.34 4.008.014 1.336.49 2.448 1.427 3.331.425.404.9.716 1.427.94-.115.332-.236.65-.365.955Z" />
    </svg>
  );
}
